class VariantPickerSelect extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('[data-ref="variant-select"]');
    this.select?.addEventListener('change', this.#handleChange);

    // Synchronise le bouton "Ajouter" avec la variante par défaut (la 1ère du select trié)
    // dès le chargement, sans attendre une interaction de l'utilisateur.
    this.#syncButton();
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.#handleChange);
  }

  // Remonte le DOM jusqu'à trouver l'ancêtre commun qui contient le quick-add-component
  // (évite de dépendre du nom de classe exact de la carte produit).
  #findScope() {
    let el = this.parentElement;
    while (el) {
      if (el.querySelector('quick-add-component')) return el;
      el = el.parentElement;
    }
    return document;
  }

  #syncButton() {
    const option = this.select?.selectedOptions?.[0];
    if (!option) return;
    this.#applyOption(option);
  }

  #applyOption(option) {
    const variantId = option.value;
    const price = option.dataset.price;
    const scope = this.#findScope();

    const addToCartButton = scope.querySelector('[data-ref="add-to-cart-button"]');
    if (addToCartButton) {
      addToCartButton.dataset.variantId = variantId;
      addToCartButton.disabled = option.disabled;
    }

    const popupToggle = scope.querySelector('[data-ref="popup-toggle"]');
    if (popupToggle) {
      popupToggle.dataset.variantId = variantId;
    }

    const priceEl = scope.querySelector('.quick-add-button__price');
    if (priceEl && price) {
      priceEl.textContent = price;
    }
  }

  #handleChange = (event) => {
    const option = event.target.selectedOptions[0];
    if (!option) return;
    this.#applyOption(option);
  };
}

if (!customElements.get('variant-picker-select')) {
  customElements.define('variant-picker-select', VariantPickerSelect);
}